import menus from './menus';

const menuItems = {
    items: menus
};

export default menuItems;
